<!-- 精品果园标题信息 -->
<template>
<div class="info-block">
    <div class="div-1" v-bind:style="{backgroundImage:'url(https://gyyg.oss-cn-shenzhen.aliyuncs.com'+info.image+')'}">
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-2">{{info.region.substring(0,60)}}</div>
      <div class="div-1-4">
        <table class="div-1-4-table" border="0px">
          <tr>
            <td colspan="6">
              <div class="table-act">
                <a>联系园主</a>
                <a>预约看园</a>
                <a>关注果园</a>
                <a>分享果园</a>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-title">分享数：</td>
            <td class="td-value">{{info.price}}</td>
            <td class="td-title">浏览数：</td>
            <td class="td-value">{{info.price}}</td>
            <td class="td-title">点击数：</td>
            <td class="td-value">{{info.crop_id}}</td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <a class="td-action-1">Lv.0</a>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'SgghInfo',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-1{
  position:relative;
  height:260px;
  width:100%;
  padding:0px 0px 0px 450px;
  border:0px solid var(--color6);
  //background:#fff;
  background-size: 420px auto;
  background-repeat: no-repeat;
  background-position: 0px center;
}

.div-1-1{
  position:relative;
  height:80px;
  //background:red;
  font-size:20px;
  font-weight:600;
  text-align:left;
  line-height:40px;
  color:#000;
  padding:2px 60px 5px 0px;
}
.div-1-2{
  position:relative;
  height:40px;
  font-size:14px;
  line-height:40px;
  text-align:left;
  color:#888;
  padding:0px 10px 0px 0px;
  border-bottom:1px solid #ddd;
}

.div-1-4{
  position:relative;
  height:140px;
  //background:green;
  text-align:left;
  color:#bbb;
  padding:40px 150px 10px 0px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  text-align:left;
  width:50px;
  color:#888;
  padding-left:0px;
}

.div-1-4-table .td-value{
  text-align:left;
  font-size:14px;
  line-height:30px;
  color:var(--color6);
}

.table-act{
  display:flex;
  justify-content:space-between;
  position:relative;
  width:100%;
  height:30px;
}

.table-act a{
  display:block;
  height:30px;
  width:100px;
  border:1px solid var(--color2);
  text-align:center;
  line-height:30px;
  color:#515151;
}

.table-act a:hover{
  cursor:pointer;
  background:var(--color2);
  color:#ffffff;
}

.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:100px;
  margin:5px 0px 5px 0px;
  padding-left:10px;
  //background:yellow;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:40px;
  padding:5px 5px 5px 5px;
  margin-top:0px;
  background:var(--color6);
  color:#fff;
  line-height:20px;
  text-align:center;
}

.div-3 .td-action-1:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}


.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/JpgyInfo1.vue